import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for `/guests/*` — same fix as `approvals.tsx`/`bookings.tsx`. */
export const Route = createFileRoute('/guests')({
  component: GuestsLayout,
});

function GuestsLayout() {
  return <Outlet />;
}
